import {
    GET_COMPANY_DETAILS, EDIT_COMPANY, APPLY_THEME, GET_COMPANY_COLORS, GET_COMPANY_PLANS, SHOW_WARNING, HIDE_WARNING,
    GET_FEEDBACK_QUESTIONS,
    SELECT_FEEDBACK,
    SELECT_ALL_FEEDBACK,
    GET_SKILLS,
    SEARCH_SKILL,
    REMOVE_SKILL,
    ADD_SKILL_TO_FEEDBACK,
    REMOVE_FEEDBACK_SKILL,
    GET_FEEDBACK_SKILLS,
    SEARCH_FEEDBACK_SKILL,
    GET_ADMIN_FEEDBACK_QUESTIONS
} from '../../actionType/type';

let intialState = {
    theme: (JSON.parse(localStorage.getItem('theme')) || {}),
    alert: false,
    plans: {}
}

export default function accountReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_COMPANY_DETAILS:
            stateCopy.companyDetails = action.payload;
            localStorage.setItem('company', action.payload.name)
            return stateCopy;
        case EDIT_COMPANY:
            return stateCopy;
        case GET_COMPANY_COLORS:
            stateCopy.theme = action.payload;
            localStorage.setItem('theme', JSON.stringify(action.payload));
            return stateCopy;
        case APPLY_THEME:
            stateCopy.theme = action.payload;
            return stateCopy;
        case GET_COMPANY_PLANS:
            stateCopy.plans = action.payload;
            localStorage.setItem('plans', JSON.stringify(action.payload))
            return stateCopy;
        case SHOW_WARNING:
            stateCopy.alert = true;
            return stateCopy;
        case HIDE_WARNING:
            stateCopy.alert = false;
            return stateCopy;
        case GET_ADMIN_FEEDBACK_QUESTIONS:
            stateCopy.feedbackQuestions = action.payload.question_details;
            stateCopy.feedbackCompanyDetails = action.payload.company_details;
            stateCopy.selectedSkills = action.payload.company_details.skills;
            return stateCopy;
        case GET_FEEDBACK_SKILLS:
            stateCopy.skills = action.payload;
            stateCopy.skillsCopy = action.payload;
            return stateCopy;
        case SEARCH_FEEDBACK_SKILL:
            if (action.payload === '') {
                stateCopy.skills = [];
            }
            else {
                const filterResult = stateCopy.skillsCopy.filter(el => {
                    const isNotSelected = !stateCopy.selectedSkills.some(selected => 
                        selected.skill_id === el._id || selected._id === el._id
                    );
                    const matchesSearch = el.title.toLowerCase().includes(action.payload.toLowerCase());
                    
                    return isNotSelected && matchesSearch;
                });
                stateCopy.skills = filterResult;
            }
            return stateCopy;
        case SELECT_FEEDBACK:
            if (action.payload.checked) {
                stateCopy.feedbackQuestions.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.active = true
                    }
                })
            }
            else {
                stateCopy.feedbackQuestions.forEach(el => {
                    if (el._id === action.payload.id) {
                        el.active = false
                    }
                })
            }
            return stateCopy;
        case SELECT_ALL_FEEDBACK:
            if (action.payload) {
                stateCopy.feedbackQuestions.forEach(el => {
                    el.active = true
                })
            }
            else {
                stateCopy.feedbackQuestions.forEach(el => {
                    el.active = false
                })
            }
            return stateCopy;
        case REMOVE_FEEDBACK_SKILL:
            const filtered = stateCopy.selectedSkills.filter(el => el._id !== action.payload._id );
            stateCopy.skills = [...stateCopy.skills, action.payload];
            stateCopy.skillsCopy = [...stateCopy.skillsCopy, action.payload];
            stateCopy.selectedSkills = filtered;
            return stateCopy;
        case ADD_SKILL_TO_FEEDBACK:
            const filter = stateCopy.skills.filter(el => el._id !== action.payload._id);
            const filterCopy = stateCopy.skillsCopy.filter(el => el._id !== action.payload._id);
            stateCopy.skills = filter;
            stateCopy.skillsCopy = filterCopy;
            stateCopy.selectedSkills = [...stateCopy.selectedSkills, action.payload];
            return stateCopy;
        default:
            return state;
    }
}